var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "017---Chat-Bot",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30,
    cy: 30,
    fill: "#02a9f4",
    r: 29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m30 1c-.5033333 0-1.0033333.01266667-1.5.038 15.4192225.79012792 27.5158989 13.5225465 27.5158989 28.962s-12.0966764 28.1718721-27.5158989 28.962c.4973333.0253333.9973333.038 1.5.038 16.0162576-.0000002 28.9999996-12.9837424 28.9999996-29s-12.983742-28.99999976-28.9999996-29z",
    fill: "#0377bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m51 27.818c0 13.637-9.4 18.182-21 18.182s-21-4.545-21-18.182c0-12.727 9.4-21.818 21-21.818s21 9.091 21 21.818z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m30 6c-.506 0-1 .039-1.5.073 10.9.75 19.5 9.574 19.5 21.745 0 13.041-8.6 17.756-19.5 18.144.5.018.994.038 1.5.038 11.6 0 21-4.545 21-18.182 0-12.727-9.4-21.818-21-21.818z",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#607d8b",
    height: 22,
    rx: 11,
    width: 34,
    x: 13,
    y: 19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m36 19h-3c6.0751322 0 11 4.9248678 11 11s-4.9248678 11-11 11h3c6.0751322 0 11-4.9248678 11-11s-4.9248678-11-11-11z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 20,
    cy: 28,
    fill: "#00bcd4",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40,
    cy: 28,
    fill: "#00bcd4",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 32h6c.5522847 0 1 .4477153 1 1 0 2.209139-1.790861 4-4 4s-4-1.790861-4-4c0-.5522847.4477153-1 1-1z",
    fill: "#00bcd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m43 51v4.92c-8.1801822 4.106677-17.8198178 4.106677-26 0v-4.92c0-2.7614237 2.2385763-5 5-5h16c2.7614237 0 5 2.2385763 5 5z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m38 46h-3c2.7614237 0 5 2.2385763 5 5v4.92c-3.5783994 1.8062417-7.4963439 2.8405791-11.5 3.036.5.025 1 .044 1.5.044 4.5153153.0105194 8.9693747-1.0447501 13-3.08v-4.92c0-2.7614237-2.2385763-5-5-5z",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 46h8v5c0 2.209139-1.790861 4-4 4s-4-1.790861-4-4z",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m31 46v5c-.0032957 1.6269922-.9917334 3.08988-2.5 3.7 1.2315812.5040787 2.6334251.3608094 3.7375754-.3819826 1.1041502-.7427919 1.7651788-1.9872732 1.7624246-3.3180174l.0000086-5z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m30 0c-16.5685425 0-30 13.4314575-30 30s13.4314575 30 30 30 30-13.4314575 30-30c-.018737-16.5607751-13.4392249-29.98126296-30-30zm-12 55.293v-4.293c0-2.209139 1.790861-4 4-4h3v4c0 2.7614237 2.2385763 5 5 5s5-2.2385763 5-5v-4h3c2.209139 0 4 1.790861 4 4v4.293c-7.5928905 3.6093633-16.4071095 3.6093633-24 0zm12-48.293c11.4 0 20 8.95 20 20.818 0 11.401-6.729 17.182-20 17.182s-20-5.781-20-17.182c0-11.868 8.6-20.818 20-20.818zm3 40v4c0 1.6568542-1.3431458 3-3 3s-3-1.3431458-3-3v-4zm11 7.233v-3.233c-.0026688-2.4078548-1.4421868-4.5816923-3.658-5.524 7.658-2.613 11.658-8.576 11.658-17.658.0189435-3.3782936-.6620258-6.7238956-2-9.826v-5.992c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v2.369c-4.0473745-5.9459878-10.8078634-9.46482229-18-9.369-7.1921366-.09582229-13.9526255 3.4230122-18 9.369v-2.369c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v5.992c-1.33797423 3.1021044-2.01894349 6.4477064-2 9.826 0 9.082 4 15.045 11.658 17.658-2.2158132.9423077-3.6553312 3.1161452-3.658 5.524v3.233c-10.97510443-6.3364795-16.32592628-19.2545062-13.04592314-31.4956446 3.28000315-12.2411384 14.37296414-20.75306671 27.04592314-20.75306671s23.76592 8.51192831 27.0459231 20.75306671c3.2800032 12.2411384-2.0708187 25.1591651-13.0459231 31.4956446z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m24 42h12c6.627417 0 12-5.372583 12-12s-5.372583-12-12-12h-12c-6.627417 0-12 5.372583-12 12s5.372583 12 12 12zm0-22h12c5.5228475 0 10 4.4771525 10 10s-4.4771525 10-10 10h-12c-5.5228475 0-10-4.4771525-10-10s4.4771525-10 10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 16h6c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-6c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m29 13h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m20 31c1.6568542 0 3-1.3431458 3-3s-1.3431458-3-3-3-3 1.3431458-3 3 1.3431458 3 3 3zm0-4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1-1-.4477153-1-1 .4477153-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m40 31c1.6568542 0 3-1.3431458 3-3s-1.3431458-3-3-3-3 1.3431458-3 3 1.3431458 3 3 3zm0-4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1-1-.4477153-1-1 .4477153-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m30 38c2.7600532-.0033061 4.9966939-2.2399468 5-5 0-1.1045695-.8954305-2-2-2h-6c-1.1045695 0-2 .8954305-2 2 .0033061 2.7600532 2.2399468 4.9966939 5 5zm3-5c0 1.6568542-1.3431458 3-3 3s-3-1.3431458-3-3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotAvatar);
export default __webpack_public_path__ + "static/media/bot_avatar.9697b17f32334b5276f01db73d78223b.svg";
export { ForwardRef as ReactComponent };